export default {
  aigc_dataAnalysis_title: 'ChatBI - Data Analysis',
  aigc_dataAnalysis_view: '查看示例',
  aigc_dataAnalysis_copy: '复制',
  aigc_dataAnalysis_refine: '优化',
  aigc_dataAnalysis_explain: '解释',
  aigc_dataAnalysis_generate: '生成',
  aigc_dataAnalysis_evaluate: '评估',
  aigc_dataAnalysis_recommend: '推荐',
  aigc_dataAnalysis_visualization: '可视化',
  aigc_dataAnalysis_ready: '准备好了吗？上传文件开始吧。',
  aigc_dataAnalysis_click_or_drag: '点击或拖动文件到此区域进行上传',
  aigc_dataAnalysis_upload_type: '上传.json,.xlsx,.xls,.csv文件以生成可视化',
  aigc_dataAnalysis_don_have_data: '没有数据？请尝试以下任意文件。',
  aigc_dataAnalysis_data_summary: '数据摘要',
  aigc_dataAnalysis_goals: '目标',
  aigc_dataAnalysis_an_enriched: '数据的丰富表示（包括预测的语义类型和描述）',
  aigc_dataAnalysis_view_raw_summary: '查看原始摘要？',
  aigc_dataAnalysis_goal_exploration: '目标探索',
  aigc_dataAnalysis_automatically: '根据上述数据摘要自动生成的数据探索目标列表。',
  aigc_dataAnalysis_visualization_generation: '可视化生成',
  aigc_dataAnalysis_select_goal: '选择上方的一个目标或描述一个新的可视化目标以生成可视化。',
  aigc_dataAnalysis_modify_chart: '使用自然语言命令修改图表。',
  aigc_dataAnalysis_visualization_created: '这个可视化是如何创建的？请查看下面的规格和代码。',
  aigc_dataAnalysis_PCU_over_time: ' PCU随时间的趋势是什么？',
  aigc_dataAnalysis_python_code: 'Python 代码',
  aigc_dataAnalysis_generate_an_explanation: '使用下面的解释可视化按钮来为图表生成解释',
  aigc_dataAnalysis_evaluate_the_chart: '评估图表',
  aigc_dataAnalysis_generate_self_evaluation: '使用下面的评估可视化按钮为图表生成自我评估分数。',
  aigc_dataAnalysis_generate_similar_charts: '生成类似的图表。',
  aigc_dataAnalysis_generate_recommendations: '生成推荐',
  aigc_dataAnalysis_change_x_axis: '将x轴标签更改为每秒米数',
  aigc_dataAnalysis_evaluated_across: `可视化已经在多个维度上进行了评估。选择一个维度来查看得分的理由。`,
  aigc_dataAnalysis_unique_values: `唯一值`,
  aigc_dataAnalysis_max: `最大值`,
  aigc_dataAnalysis_min: `最小值`,
  aigc_dataAnalysis_std: `标准`,
  aigc_dataAnalysis_no_data: `加载失败，请刷新页面.`,
  aigc_dataAnalysis_refresh: `刷新`,
  aigc_dataAnalysis_dictionary_below: `该数据集总结为下面的字典。`,
  aigc_dataAnalysis_raw_dataset_summary: `原始数据集摘要`,
  aigc_dataAnalysis_successful: `复制成功`,
  aigc_dataAnalysis_replication: `复制失败`,
};